import { SelectField } from '@components/forms/SelectField'
import { PenNameFieldProps } from './interface'

export function PenNameField({ penNameOptions }: PenNameFieldProps) {
  return (
    <SelectField name='penNameId' label='นามปากกา' options={penNameOptions} />
  )
}
